// DatePicker.tsx
import React, {useRef, useEffect, useState} from 'react'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import moment from 'moment'

interface DatePickerProps {
  label: string
  name: string
  field?: any
  form?: any
  options?: any
  dateFormat?: string
  labelFormat?: string
  enableTime?: boolean
  dateOnly?: boolean
  className?: string
  useFormik?: boolean
  onChange?: any
  value?: any
  disabled?: boolean
  minDate?: any
  maxDate?: any
  showToday?: boolean
  isStatic?: boolean
}

const DatePicker: React.FC<DatePickerProps> = ({
  field,
  form,
  label,
  name,
  options,
  className = '',
  dateFormat = 'Y-m-d',
  labelFormat = 'd/m/Y',
  enableTime = false,
  dateOnly,
  useFormik = true,
  onChange,
  value,
  disabled = false,
  minDate,
  maxDate,
  showToday = false,
  isStatic = true,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const flatpickrInstance = useRef<flatpickr.Instance | null>(null)
  const [uuid, setUuid] = useState('fp' + Math.random().toString(36).substring(2, 10))

  useEffect(() => {
    if (inputRef.current) {
      // console.log(inputRef.current)

      flatpickrInstance.current = flatpickr(inputRef.current, {
        ...options,
        dateFormat: dateFormat,
        altFormat: labelFormat,
        altInput: true,
        enableTime: enableTime,
        time_24hr: true,
        defaultDate: value || undefined,
        static: isStatic,
        closeOnSelect: false,
        minDate: minDate,
        maxDate: maxDate,
        minTime: minDate,
        maxTime: maxDate,
        onClose: (selectedDates: Date[], dateStr, instance) => {
          // const parentElement = document.querySelector('#' + uuid)
          // if (parentElement && parentElement.children.length >= 2) {
          //   const secondChild = parentElement.children[1] as HTMLElement
          //   secondChild.focus()
          // }

          if (useFormik) {
            if (!selectedDates || selectedDates.length === 0) {
              return
            }
            if (dateOnly) {
              form.setFieldValue(name, moment(selectedDates[0]).format('YYYY-MM-DD'))
              return
            } else {
              form.setFieldValue(name, selectedDates[0].toISOString())
              return
            }
          } else {
            onChange(selectedDates)
          }
        },
        onChange: () => {
          if (!enableTime) {
            flatpickrInstance.current?.close()
          }
        },
      })
    }

    if (showToday) {
      const todayButton = document.createElement('button')
      todayButton.textContent = 'Hari Ini'
      todayButton.classList.add('flatpickr-today-btn')
      todayButton.classList.add('btn')
      todayButton.classList.add('btn-primary')
      todayButton.style.margin = '10px' // styling optional

      const calendarContainer = flatpickrInstance.current?.calendarContainer
      calendarContainer?.appendChild(todayButton)

      todayButton.addEventListener('click', function () {
        const today = new Date()
        flatpickrInstance.current?.setDate([today]) // Set tanggal ke hari ini
        flatpickrInstance.current?.close()
      })
    }

    return () => {
      if (flatpickrInstance.current) {
        flatpickrInstance.current.destroy()
      }
    }
  }, [options, value, onChange])

  return (
    <div id={uuid}>
      <input
        ref={inputRef}
        type='text'
        className={`form-control date-picker ${className}`}
        disabled={disabled}
        placeholder={label}
      />
    </div>
  )
}

export default DatePicker
